import * as ContactUtils from "../../middleware/Utils/ContactUtils";
export { Roles } from "../../middleware/Utils/ContactUtils";

export const isValidEmail = (email) => {
    if (!email || email.length === 0) {
        return false;
    }

    // const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //const pattern = /^[a-zA-Z0-9]+@(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,})$/;
    return pattern.test(email);
}

export const isValidPassword = (password) => {
    if (!password || password.length === 0) {
        return false;
    }

    return true;
}

export const getUserRole = (contact) => {
    if (!contact) {
        return "";
    }

    return roleDisplayName(contact);
}

const roleName = {
    user: "USER",
    superAdmin: "SUPERADMIN",
    applicationSupport: "APPLICATION SUPPORT",
    support: "SUPPORT",
    appSuperAdmin: "ADMIN",
    internalDeveloperAndAppSuperAdmin: "INTERNAL_DEV+ADMIN",
    developerAndAppSuperAdmin: "DEV+ADMIN",
    internalDeveloper: "INTERNAL DEVELOPER",
    developer: "DEVELOPER",
    companyAdmin: "COMPANY ADMIN"
}

export function roleDisplayName(contact) {
    let role = [];

    if (ContactUtils.isInternalDeveloper(contact))
        role.push(roleName.internalDeveloper);
    else if (ContactUtils.isDeveloper(contact))
        role.push(roleName.developer);

    if (ContactUtils.isSuperAdmin(contact))
        role.push(roleName.superAdmin);

    if (ContactUtils.isAppSuperAdmin(contact))
        role.push(roleName.appSuperAdmin);

    if (ContactUtils.isAppSupport(contact))
        role.push(roleName.applicationSupport);

    if (ContactUtils.isSupport(contact))
        role.push(roleName.support);

    if (ContactUtils.isCompanyAdmin(contact))
        role.push(roleName.companyAdmin);

    if (role.length === 0)
        role.push(roleName.user);

    return role.toString().replace(/,/g, ", ");
}

export const getLoginEmail = (user) => {
    if (!user) {
        return "";
    }

    return user?.loginEmail;
}
